export default "__VITE_ASSET__Ddm02okm__"